import { useHistory, useLocation } from "react-router-dom";
import { useInvoice } from "./use-invoice";

export function useQuickPayViewDrawer() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const invoiceId = queryParams.get("quickpay_view");

  const { data: invoice, ...rest } = useInvoice({
    invoiceId,
    enabled: !!invoiceId,
  });

  const handleOpen = (id) => {
    if (queryParams.has("quickpay_view")) {
      queryParams.delete("quickpay_view");
    }

    queryParams.set("quickpay_view", id);

    history.push({
      search: queryParams.toString(),
    });
  };

  const handleClose = () => {
    if (queryParams.has("quickpay_view")) {
      queryParams.delete("quickpay_view");

      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  return {
    open: queryParams.has("quickpay_view"),
    drawerData: invoice,
    handleClose,
    handleOpen,
    ...rest,
  };
}
